
const ApprovedExpenses = (): JSX.Element => {
    return (
        <div>
           <p>Approved expenses</p> 
        </div>
    );
};

export default ApprovedExpenses;
